import router from '../router'
export default {
    _goRouter(_url, _param) {
        router.push({
            path: _url,
            query: _param ? _param : {}
        }).catch((err) => { })
    },
}